import React from 'react';
import { Box } from '@mui/material';
import { useViewContext } from '../context/ViewContext';
import CanopyView from '../views/CanopyView';
import DashboardView from '../views/DashboardView';
import FleetView from '../views/FleetView';
import ArchiveView from '../views/ArchiveView';
import BrowserView from '../views/BrowserView';
import ImportView from '../views/ImportView';
import UserManagementView from '../views/UserManagementView';
import DownloadsView from '../views/DownloadsView';
import HelpView from '../views/HelpView';
import BessView from '../views/BessView';
import EmsView from '../views/EmsView';
import CustomerLoadView from '../views/CustomerLoadView';
import PccView from '../views/PccView';
import EnergyReportsView from '../views/EnergyReportsView';
import SettingsView from '../views/SettingsView';

/**
 * ViewContainer component handles view switching based on current view state
 */
function ViewContainer() {
  const { currentView } = useViewContext();

  // Render the appropriate view based on currentView
  const renderView = () => {
    switch (currentView) {
      case 'canopyView':
        return <CanopyView />;
      case 'dashboard':
        return <DashboardView />;
      case 'bessView':
        return <BessView />;
      case 'emsView':
        return <EmsView />;
      case 'loadView':
        return <CustomerLoadView />;
      case 'pccView':
        return <PccView />;
      case 'energyReports':
        return <EnergyReportsView />;
      case 'settings':
        return <SettingsView />;
      case 'fleetView':
        return <FleetView />;
      case 'archiveView':
        return <ArchiveView />;
      case 'browserView':
        return <BrowserView />;
      case 'importData':
        return <ImportView />;
      case 'userManagement':
        return <UserManagementView />;
      case 'downloads':
        return <DownloadsView />;
      case 'help':
        return <HelpView />;
      default:
        return <DashboardView />;
    }
  };

  return (
    <Box 
      component="main" 
      sx={{ 
        flexGrow: 1, 
        overflow: 'auto',
        p: 2 // Add some padding
      }}
    >
      {renderView()}
    </Box>
  );
}

export default ViewContainer;
